import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";

const AdminHome = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (!storedUsername) {
      navigate("/adminlogin");
    } else {
      setUsername(storedUsername);
    }
  }, [navigate]);

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="container">
      <div className="admin-wrap fade-in">
        {/* <div className="box-head">
          <span>Administration : जल बुकिंग</span>
        </div> */}

        <div className="welcome-box">
          <h2>Welcome, <span className="highlight">{username}</span> 👋</h2>
          <p>Manage bookings, deliveries, and reports from one place.</p>
        </div>

        <div className="admin-actions">
          <div className="admin-card" onClick={() => handleNavigate("/directbooking")}>
            <h3>📘 Direct Booking</h3>
            <p>Create a new water booking directly.</p>
          </div>

          <div className="admin-card" onClick={() => handleNavigate("/updatedelivery")}>
            <h3>🚚 Update Delivery</h3>
            <p>Mark water deliveries as completed.</p>
          </div>

          <div className="admin-card" onClick={() => handleNavigate("/bookingreport")}>
            <h3>📊 Reports</h3>
            <p>Generate daily booking & delivery reports.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminHome;
